import { useContext, useEffect, useState } from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import * as Yup from 'yup';

import { Form, MultiSelect } from '../../../Components/Form';
import Loading from '../../../Components/Loading/Loading';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import { serverErrorHandler } from '../../../Utils/Helpers';
import { UserContext } from '../Context/UserContext';

const validationSchema = Yup.object({
  role_names: Yup.array()
    .typeError('انتخاب نقش الزامی است')
    .required('انتخاب نقش الزامی است'),
});

const Role = () => {
  const { id } = useParams();
  const context = useContext(UserContext);
  const [formSubmitLoading, setFormSubmitLoaing] = useState(false);
  const [serverErrors, setServerErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const { get, post } = useApi();
  const { error, success } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    const getData = async () => {
      await getUser();
      await getRoles();
    };
    getData();
  }, [id]);

  const getRoles = async () => {
    setLoading(true);
    await get(
      '/role',
      (res) => {
        context.roles = res?.data;
        setLoading(false);
      },
      (err) => {
        error('دریافت نقش ها با خطا مواجه شد');
        setLoading(false);
      },
    );
  };
  const getUser = async () => {
    setLoading(true);
    await get(
      `/user/${id}`,
      (res) => {
        context.user = res?.data;
      },
      (err) => {
        error('دریافت نقش ها با خطا مواجه شد');
        setLoading(false);
      },
    );
  };

  const submitForm = async (values, setSubmitingForm) => {
    setFormSubmitLoaing(true);
    values['user_id'] = context.user?.id;
    await post(
      '/user/role',
      values,
      (res) => {
        success('نقش با موفقیت به کاربر اضافه شد.');
        setFormSubmitLoaing(false);
        navigate(`/user/${id}/role`);
      },
      (err) => {
        if (err?.status === 422) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error('لطفا خطاهای فرم را رفع کنید.');
        } else {
          error('خطا در تعیین نقش');
        }
        setFormSubmitLoaing(false);
      },
    );
  };
  return loading ? (
    <Loading />
  ) : (
    <Master>
      <TitleBar
        title={`نقش های "${context.user?.name} ${context.user?.last_name}"`}
        showBackBtn={true}
        showCreateBtn={false}
        showFilterBtn={false}
        backPath='/user'
      />
      <Form
        initialValues={{
          role_names: context.user?.roles?.map((r) => r.name),
        }}
        loading={formSubmitLoading}
        onSubmit={submitForm}
        validationSchema={validationSchema}
      >
        <div className='row'>
          <div className='col-12 col-md-8'>
            <div className='row'>
              <div className='col-12'>
                <MultiSelect
                  defaultValue={context.user?.roles}
                  title='نقش ها'
                  name='role_names'
                  getOptionLabel={(t) => t?.description}
                  getOptionValue={(t) => t?.name}
                  options={context.roles}
                  serverError={serverErrors.provinces}
                />
              </div>
            </div>
          </div>
        </div>
      </Form>
    </Master>
  );
};

export default Role;
